"use client"

// src/components/fade.ts
var Fade = {
  baseStyle: {
    w: "100%"
  }
};

export {
  Fade
};
//# sourceMappingURL=chunk-UKMHCQUV.mjs.map